// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/index.css */

/* ============================================
   DESIGN TOKENS (from mockup visual language)
   ============================================ */
:root {
  /* --- Color Palette --- */
  --color-cream-bg: #FDF6EC;
  --color-wood-dark: #5C3A1E;
  --color-wood-medium: #8B5E3C;
  --color-wood-light: #A97C50;
  --color-wood-header: linear-gradient(180deg, #6B4226 0%, #8B5E3C 100%);
  --color-card-white: #FFFFFF;
  --color-card-shadow: rgba(0, 0, 0, 0.08);
  --color-text-primary: #2C2C2C;
  --color-text-secondary: #6B6B6B;
  --color-text-light: #999999;
  --color-text-on-wood: #FDF6EC;
  --color-border: #E8E0D4;
  --color-progress-bg: #E8E0D4;
  --color-success: #4CAF50;
  --color-error: #E53935;
  --color-accent: #FF8F00;

  /* --- Leitner Compartment Colors --- */
  --color-fach-1: #E53935;
  --color-fach-2: #FF8F00;
  --color-fach-3: #FDD835;
  --color-fach-4: #66BB6A;
  --color-fach-5: #42A5F5;

  /* --- Typography --- */
  --font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-size-xs: 0.75rem;
  --font-size-sm: 0.875rem;
  --font-size-base: 1rem;
  --font-size-md: 1.125rem;
  --font-size-lg: 1.25rem;
  --font-size-xl: 1.5rem;
  --font-size-2xl: 2rem;
  --font-weight-normal: 400;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --font-weight-extrabold: 800;
  --line-height-tight: 1.2;
  --line-height-normal: 1.5;

  /* --- Spacing --- */
  --space-xs: 0.25rem;
  --space-sm: 0.5rem;
  --space-md: 1rem;
  --space-lg: 1.5rem;
  --space-xl: 2rem;
  --space-2xl: 3rem;

  /* --- Border Radius --- */
  --radius-sm: 0.375rem;
  --radius-md: 0.75rem;
  --radius-lg: 1rem;
  --radius-xl: 1.5rem;
  --radius-full: 9999px;

  /* --- Shadows --- */
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06);
  --shadow-md: 0 2px 8px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 4px 16px rgba(0, 0, 0, 0.12);

  /* --- Layout --- */
  --header-height: 2.75rem;
  --bottom-nav-height: 3.25rem;
  --max-content-width: 480px;
  --content-padding: var(--space-md);

  /* --- Transitions --- */
  --transition-fast: 150ms ease;
  --transition-normal: 250ms ease;
  --transition-slow: 350ms ease;
}

/* ============================================
   RESET & BASE STYLES
   ============================================ */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  font-family: var(--font-family);
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
  padding: 0;
  background-color: var(--color-cream-bg);
  color: var(--color-text-primary);
  line-height: var(--line-height-normal);
  min-height: 100vh;
  min-height: 100dvh;
  overflow-x: hidden;
}

#root {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

a {
  color: inherit;
  text-decoration: none;
}

button {
  font-family: inherit;
  cursor: pointer;
  border: none;
  background: none;
  font-size: inherit;
}

ul, ol {
  list-style: none;
}

img, svg {
  display: block;
  max-width: 100%;
}

input, textarea, select {
  font-family: inherit;
  font-size: inherit;
}

/* ============================================
   UTILITY CLASSES
   ============================================ */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* ============================================
   RESPONSIVE CONTAINER
   ============================================ */
@media (min-width: 481px) {
  #root {
    max-width: var(--max-content-width);
    margin: 0 auto;
    box-shadow: var(--shadow-lg);
    position: relative;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAIvE;;iDAEiD;AACjD;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sEAAsE;EACtE,2BAA2B;EAC3B,wCAAwC;EACxC,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;;EAEvB,uCAAuC;EACvC,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,uBAAuB;EACvB,0FAA0F;EAC1F,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;;EAEzB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;EAEjB,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;;EAErB,oBAAoB;EACpB,0CAA0C;EAC1C,yCAAyC;EACzC,2CAA2C;;EAE3C,mBAAmB;EACnB,wBAAwB;EACxB,4BAA4B;EAC5B,0BAA0B;EAC1B,kCAAkC;;EAElC,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;;iDAEiD;AACjD;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;EACnC,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,uCAAuC;EACvC,gCAAgC;EAChC,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;iDAEiD;AACjD;EACE;IACE,mCAAmC;IACnC,cAAc;IACd,4BAA4B;IAC5B,kBAAkB;EACpB;AACF","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/index.css */\n\n@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&display=swap');\n\n/* ============================================\n   DESIGN TOKENS (from mockup visual language)\n   ============================================ */\n:root {\n  /* --- Color Palette --- */\n  --color-cream-bg: #FDF6EC;\n  --color-wood-dark: #5C3A1E;\n  --color-wood-medium: #8B5E3C;\n  --color-wood-light: #A97C50;\n  --color-wood-header: linear-gradient(180deg, #6B4226 0%, #8B5E3C 100%);\n  --color-card-white: #FFFFFF;\n  --color-card-shadow: rgba(0, 0, 0, 0.08);\n  --color-text-primary: #2C2C2C;\n  --color-text-secondary: #6B6B6B;\n  --color-text-light: #999999;\n  --color-text-on-wood: #FDF6EC;\n  --color-border: #E8E0D4;\n  --color-progress-bg: #E8E0D4;\n  --color-success: #4CAF50;\n  --color-error: #E53935;\n  --color-accent: #FF8F00;\n\n  /* --- Leitner Compartment Colors --- */\n  --color-fach-1: #E53935;\n  --color-fach-2: #FF8F00;\n  --color-fach-3: #FDD835;\n  --color-fach-4: #66BB6A;\n  --color-fach-5: #42A5F5;\n\n  /* --- Typography --- */\n  --font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-size-xs: 0.75rem;\n  --font-size-sm: 0.875rem;\n  --font-size-base: 1rem;\n  --font-size-md: 1.125rem;\n  --font-size-lg: 1.25rem;\n  --font-size-xl: 1.5rem;\n  --font-size-2xl: 2rem;\n  --font-weight-normal: 400;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  --font-weight-extrabold: 800;\n  --line-height-tight: 1.2;\n  --line-height-normal: 1.5;\n\n  /* --- Spacing --- */\n  --space-xs: 0.25rem;\n  --space-sm: 0.5rem;\n  --space-md: 1rem;\n  --space-lg: 1.5rem;\n  --space-xl: 2rem;\n  --space-2xl: 3rem;\n\n  /* --- Border Radius --- */\n  --radius-sm: 0.375rem;\n  --radius-md: 0.75rem;\n  --radius-lg: 1rem;\n  --radius-xl: 1.5rem;\n  --radius-full: 9999px;\n\n  /* --- Shadows --- */\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06);\n  --shadow-md: 0 2px 8px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 4px 16px rgba(0, 0, 0, 0.12);\n\n  /* --- Layout --- */\n  --header-height: 2.75rem;\n  --bottom-nav-height: 3.25rem;\n  --max-content-width: 480px;\n  --content-padding: var(--space-md);\n\n  /* --- Transitions --- */\n  --transition-fast: 150ms ease;\n  --transition-normal: 250ms ease;\n  --transition-slow: 350ms ease;\n}\n\n/* ============================================\n   RESET & BASE STYLES\n   ============================================ */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  font-family: var(--font-family);\n  font-size: 16px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  background-color: var(--color-cream-bg);\n  color: var(--color-text-primary);\n  line-height: var(--line-height-normal);\n  min-height: 100vh;\n  min-height: 100dvh;\n  overflow-x: hidden;\n}\n\n#root {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n  border: none;\n  background: none;\n  font-size: inherit;\n}\n\nul, ol {\n  list-style: none;\n}\n\nimg, svg {\n  display: block;\n  max-width: 100%;\n}\n\ninput, textarea, select {\n  font-family: inherit;\n  font-size: inherit;\n}\n\n/* ============================================\n   UTILITY CLASSES\n   ============================================ */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* ============================================\n   RESPONSIVE CONTAINER\n   ============================================ */\n@media (min-width: 481px) {\n  #root {\n    max-width: var(--max-content-width);\n    margin: 0 auto;\n    box-shadow: var(--shadow-lg);\n    position: relative;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
